import { useSyncExternalStore } from "react";

/** Minimal external store with React binding. */
export class Store<T> {
  #state: T;
  #listeners = new Set<() => void>();
  constructor(initial: T) {
    this.#state = initial;
  }
  get(): T {
    return this.#state;
  }
  set(next: T | ((prev: T) => T)): void {
    this.#state = typeof next === "function" ? (next as (prev: T) => T)(this.#state) : next;
    for (const l of this.#listeners) l();
  }
  subscribe = (l: () => void): (() => void) => {
    this.#listeners.add(l);
    return () => {
      this.#listeners.delete(l);
    };
  };
}

export function useStore<T>(store: Store<T>): T {
  return useSyncExternalStore(
    store.subscribe,
    () => store.get(),
    () => store.get(),
  );
}
